import React from 'react';
import { Container, Title, TitleProps } from '@soluto-design/react';
import { LinkProps } from '@soluto-design/link';

import BlockListItem from '../../molecules/BlockListItem';

export interface BlockListLargeSectionProps {
    title: string;
    items?: LinkProps[];
    titleTag?: TitleProps['component'];
}

export default function BlockListLargeSection({
    title,
    items = [],
    titleTag = 'h3',
}: BlockListLargeSectionProps) {
    return (
        <section className="my-xxxl">
            <Container className="row">
                {title && (
                    <Title
                        isHtml
                        component={titleTag}
                        className="col-span-full lg:col-span-3 xl:col-span-5 text-h200 text-text-primary [&>em]:font-regular-italic [&>i]:font-regular-italic pb-xl lg:pb-0">
                        {title}
                    </Title>
                )}
                {items && items.length > 0 && (
                    <ul className="col-span-full lg:col-span-4 lg:col-start-5 xl:col-span-6 xl:col-start-7">
                        {items.map((item, index) => (
                            <li
                                key={`blocklist-large-${index}`}
                                className="list-none border-t-small border-stroke-secondary">
                                <BlockListItem {...item} />
                            </li>
                        ))}
                    </ul>
                )}
            </Container>
        </section>
    );
}
